import { render } from "./orders_stat.vue?vue&type=template&id=12c0f473"
import script from "./orders_stat.vue?vue&type=script&lang=js"
export * from "./orders_stat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__